module.exports = __webpack_public_path__ + "static/media/2019-04-11-02.1311c414.jpg";